import React from "react";

const lazy = (p) =>
  React.lazy(() => import(`@pages/new-product/components/${p}`));

export const PRODUCT_STEPS_MAP = {
  Hotel: {
    1: lazy("Title"),
    2: lazy("Location"),
    3: lazy("Description"),
    4: lazy("Informations"),
    5: lazy("hotelComponents/General"),
    6: lazy("hotelComponents/ReceptionServices"),
    7: lazy("hotelComponents/Equipments"),
    8: lazy("hotelComponents/Rooming"),
    9: lazy("hotelComponents/MealRate"),
    10: lazy("Review"),
  },

  Activity: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("Informations"),
    6: lazy("Host"),
    7: lazy("StepComponent"),
    8: lazy("Description"),
    9: lazy("activityComponents/Attributes"),
    10: lazy("Keywords"),
    11: lazy("InclusionsAndRestrictions"),
    12: lazy("StepComponent"),
    13: lazy("activityComponents/Policy"),
    14: lazy("Booking"),
    15: lazy("Pricing"),
    16: lazy("Review"),
  },

  Transport: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("transportComponents/Iteneraries"),
    6: lazy("StepComponent"),
    7: lazy("Description"),
    8: lazy("transportComponents/Theme"),
    9: lazy("transportComponents/Cars"),
    10: lazy("StepComponent"),
    11: lazy("transportComponents/Policy"),
    12: lazy("Booking"),
    13: lazy("transportComponents/Pricing"),
    14: lazy("Review"),
  },

  Flight: {
    1: lazy("flightComponents/Destinations"),
    2: lazy("Location"),
    3: lazy("Type"),
    4: lazy("flightComponents/Flights"),
    5: lazy("flightComponents/Itineraries"),
    6: lazy("flightComponents/Pricing"),
    7: lazy("flightComponents/Policy"),
    8: lazy("Booking"),
    9: lazy("Review"),
  },

  Car: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("Informations"),
    6: lazy("carComponents/Details"),
    7: lazy("StepComponent"),
    8: lazy("Description"),
    9: lazy("carComponents/Attributes"),
    10: lazy("Keywords"),
    11: lazy("carComponents/Color"),
    12: lazy("StepComponent"),
    13: lazy("carComponents/Availability"),
    14: lazy("Booking"),
    15: lazy("carComponents/Pricing"),
    16: lazy("Review"),
  },

  Package: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("Informations"),
    6: lazy("Host"),
    7: lazy("StepComponent"),
    8: lazy("packageComponents/Timeline"),
    9: lazy("Description"),
    10: lazy("InclusionsAndRestrictions"),
    11: lazy("Keywords"),
    12: lazy("StepComponent"),
    13: lazy("packageComponents/Days"),
    14: lazy("StepComponent"),
    15: lazy("packageComponents/Policy"),
    16: lazy("Booking"),
    17: lazy("packageComponents/Pricing"),
    18: lazy("Review"),
  },

  Restaurant: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("Informations"),
    6: lazy("StepComponent"),
    7: lazy("Description"),
    8: lazy("restaurantComonents/Meals"),
    9: lazy("restaurantComonents/Services"),
    10: lazy("StepComponent"),
    11: lazy("restaurantComonents/Menu"),
    12: lazy("restaurantComonents/WorkingHours"),
    13: lazy("restaurantComonents/Policy"),
    14: lazy("Booking"),
    15: lazy("Review"),
  },

  Hosting: {
    1: lazy("StepComponent"),
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),
    5: lazy("Informations"),
    6: lazy("StepComponent"),
    7: lazy("Description"),
    8: lazy("hostingComponents/Attributes"),
    9: lazy("Keywords"),
    10: lazy("StepComponent"),
    11: lazy("hostingComponents/Availability"),
    12: lazy("Booking"),
    13: lazy("hostingComponents/Pricing"),
    14: lazy("Review"),
  },

  Events: {
    1: lazy("StepComponent"), // Step 1 Header
    2: lazy("Title"),
    3: lazy("Type"),
    4: lazy("Location"),

    5: lazy("StepComponent"), // Step 2 Header
    6: lazy("Description"),
    7: lazy("eventsComponents/Attributes"),

    8: lazy("StepComponent"), // Step 3 Header
    9: lazy("eventsComponents/Details"),
    10: lazy("eventsComponents/Policy"),
    11: lazy("Booking"),
    12: lazy("eventsComponents/Pricing"),

    13: lazy("Review"),
  },
};
